import React from 'react';

import TransportationCaller from './TransportationCaller';
import Create from '../../helpers/error/Create';
import Error from '../../helpers/error/Error';

async function PostQuery(path: string, params: object) {
  const searchParams = new URLSearchParams();

  // Convert object to query parameters
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      searchParams.append(key, String(value));
    }
  });

  const fullPath = `${path}?${searchParams.toString()}`;

  const options = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return TransportationCaller.post(fullPath, null, options).catch(error => {
    Create(<Error error={error} />);
  });
}

export default PostQuery;
